import {Inject, Injectable} from '@angular/core';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {standardRetry} from '@emm/core/util/rx.util';
import {SalesChannel} from '@emm/core/models/sales-channel.model';

@Injectable({
    providedIn: 'root'
})
export class SalesChannelsService {
    endpoint = '/sales-channels';

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}

    public getAllSalesChannels(): Observable<SalesChannel[]> {
        return this.http.get(`${this.apiUrl}/sales-channels`).pipe(
            map((response: any) => response),
            standardRetry()
        );
    }
}
